package horcrux.frontend.common.views.collections.importdocuments

import horcrux.frontend.common.views.collections.ImportButtonLabel
import horcrux.frontend.common.views.components.input.selectors.buttonSelector

val CreateDocumentOptionSelector = ImportButtonLabel.buttonSelector(
    helpTextMaybe = """Select ${ImportButtonLabel.CREATE_COLLECTION_AND_IMPORT.stringValue} to create a new collection from your document. Select "${ImportButtonLabel.IMPORT.stringValue}" to import your document to an existing collection.
                    """.trimIndent()
)
